<template>
    <div class="d-flex">
        <!-- Title when ready and with results, show title text and #results-->
        <div v-if="isStatusReady && count != null">
            {{ title }} ({{ count }})
        </div>
        <!-- Title when loading, show title text with a spinner-->
        <div v-else-if="isStatusLoading">
            {{ title }}
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">{{ $t('loading') }}</span>
            </div>
        </div>
        <!-- Title when error or no count, only show title text-->
        <div v-else>{{ title }}</div>
        <div
            class="close-tab-container"
            @click.stop.prevent="$emit('closeTab', $event)"
            :title="$t('closeTab')"
        >
            <img
                class="close-tab-icon"
                src="~@/assets/icons/close-new.svg"
                :alt="$t('closeTab')"
            />
        </div>
    </div>
</template>

<script>
    import { TAB_STATUS } from '../../../../constants';
    export default {
        props: {
            title: { type: String, required: false, default: '' },
            count: { type: Number, required: false, default: null },
            status: { type: String, required: false, default: TAB_STATUS.READY }
        },
        computed: {
            isStatusReady() {
                return this.status === TAB_STATUS.READY;
            },
            isStatusLoading() {
                return this.status === TAB_STATUS.LOADING;
            },
            isStatusError() {
                return this.status === TAB_STATUS.ERROR;
            }
        }
    };
</script>

<style lang="scss" scoped>
.close-tab-container {
    padding: 0px 10px;

    .close-tab-icon {
        mask: url(~@/assets/icons/close-new.svg);
        width: 10px;
        height: 20px;
        background-color: $grey-08;
        mask-size: contain;
        mask-repeat: no-repeat;
        mask-position: center;
    }
}
</style>
